<div class="collapsible-section">
  <div class="section-header" [class.expanded]="expanded()" (click)="toggleExpand()">
    <span class="section-title-wrapper">
      <img width="15" height="15" [ngSrc]="icon()" alt="Icon" />

      <h4 class="section-title">{{ title() }}</h4>
    </span>

    <i class="toggle-icon" [class.expanded]="expanded()"></i>
  </div>

  <div class="section-content" [class.expanded]="expanded()">
    <div class="content-wrapper">
      <ng-content />
    </div>
  </div>
</div>
